import * as Colyseus from "colyseus.js";

export default {
	install: (app, options) => {
		let client = new Colyseus.Client(options.server);
		app.config.globalProperties.$colyseus = { client };
	},
};
